const PlaceholderArticleImg = () => (
  <svg width="116" height="86" viewBox="0 0 116 86" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="115" height="85" rx="3.5" fill="#F4F5F6" stroke="#F4F5F6" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M68 58.5H48C45.2383 58.5 43 56.2617 43 53.5V33.5C43 30.7383 45.2383 28.5 48 28.5H68C70.7617 28.5 73 30.7383 73 33.5V53.5C73 56.2617 70.7617 58.5 68 58.5Z"
      stroke="#D5D8DB"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M54.6451 36.0203C55.7841 37.1593 55.7841 39.0061 54.6451 40.1451C53.506 41.2841 51.6593 41.2841 50.5203 40.1451C49.3813 39.006 49.3813 37.1593 50.5203 36.0203C51.6593 34.8813 53.5061 34.8813 54.6451 36.0203"
      stroke="#D5D8DB"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M72.9993 40.3477C72.2493 40.241 71.4877 40.166 70.7077 40.166C61.8477 40.166 54.666 47.3477 54.666 56.2077C54.666 56.9877 54.741 57.7493 54.8477 58.4993"
      stroke="#D5D8DB"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default PlaceholderArticleImg;
